import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CarServices from '../../services/CarServices';
import MenuListService from '../../services/MenuServices';
import MembershipServiceListServices from '../../services/MembershipServiceListServices';
function UpdateMenu({ service, closeModal, onSuccess }) {
    const [formValues, setFormValues] = useState({
        serviceId: '',
        caption: '',
        images: [] 
    });
    const [previewImages, setPreviewImages] = useState([]); // all previews
    const [existingImages, setExistingImages] = useState([]); // old image URLs
     const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    // useEffect(() => {
    //     MembershipServiceListServices.getServiceGuest().then(res => {
    //         if (res.status) setVendors(res.data);
    //     });
  
    // }, []);
    useEffect(() => {
    const fetchServices = async () => {
        try {
            const res = await MembershipServiceListServices.getServiceGuest();

            if (res?.status) {
                const formattedServices = res.data
                    .filter(item => item.title)
                    .map(item => ({
                        _id: item._id,
                        title: item.title
                    }));

                setServices(formattedServices);
            }
        } catch (error) {
            console.error("Service fetch error:", error);
        }
    };

    fetchServices();
}, []);
 
    useEffect(() => {
        if (service) {
            const imgs = service?.images || [];
            setFormValues({
                serviceId: service?.serviceId?._id || '',
                caption: service?.caption || '',
                images: [] 
            });
 
            setExistingImages(imgs);
 
            const previews = imgs.map(img => ({
                type: "existing",
                url: img
            }));
            setPreviewImages(previews);
        }
    }, [service]);
 
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({ ...prev, [name]: value }));
    };
 
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;
 
        setFormValues(prev => ({
            ...prev,
            images: [...prev.images, ...files]
        }));
 
        const previews = files.map(file => ({
            type: "new",
            url: URL.createObjectURL(file),
            file
        }));
        setPreviewImages(prev => [...prev, ...previews]);
    };
 
    const handleRemoveImage = (imgObj, index) => {
        setPreviewImages(prev => prev.filter((_, i) => i !== index));
 
        if (imgObj.type === "existing") {
            setExistingImages(prev => prev.filter(img => img !== imgObj.url));
        } else {
            setFormValues(prev => ({
                ...prev,
                images: prev.images.filter(file => file !== imgObj.file)
            }));
        }
    };
 
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
 
        try {
            const formData = new FormData();
            formData.append("serviceId", formValues.serviceId);
            formData.append("caption", formValues.caption);
            // Append existing images as binary files
            for (let imgUrl of existingImages) {
                const response = await fetch(`${process.env.REACT_APP_URL}/${imgUrl}`);
                const blob = await response.blob();
                const filename = imgUrl.split('/').pop();
                formData.append("images", new File([blob], filename, { type: blob.type }));
            }
 
            // Append new files directly
            formValues.images.forEach(file => formData.append("images", file));
 
            const res = await MenuListService.updateMenu(service._id, formData);
 
            if (res.status) {
                alert(res.message);
                onSuccess();
                closeModal();
                navigate("/menu-list");
            } else {
                alert(res.message || "Update failed ❌");
            }
        } catch (error) {
            console.error(error);
            alert(error.response?.data?.message || "Error ❌");
        } finally {
            setLoading(false);
        }
    };
 
    return (
        <div className="modal fade edit-box show d-block">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">
 
                    <div className="modal-header">
                        <h5 className='text-light'>Edit Menu</h5>
                        <button className='btn btn-danger' onClick={closeModal}>×</button>
                    </div>
 
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
 
                            <div className="row">
                                <div className="col-lg-6">
                                    <label>Select Service</label>
                                    <select
                                        name="serviceId"
                                     value={formValues.serviceId}
                                        onChange={handleInputChange}
                                        className="form-control"
                                    >
                                        <option value="">Select</option>
                                        {services.map(v => (
                                            <option key={v._id} value={v._id}>
                                                {v.title}
                                            </option>
                                        ))}
                                    </select>
                                </div>
 
                                <div className="col-lg-6">
                                    <label>Caption</label>
                                    <input
                                        type="text"
                                        name="caption"
                                        value={formValues.caption}
                                        onChange={handleInputChange}
                                        className="form-control"
                                    />
                                </div>
 
                                <div className="col-lg-12 mt-3">
                                    <label>Images (Multiple)</label>
                                    <input
                                        type="file"
                                        multiple
                                        onChange={handleFileChange}
                                        className="form-control"
                                        accept="image/*"
                                    />
 
                                    {previewImages.length > 0 && (
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 10 }}>
                                            {previewImages.map((img, i) => (
                                                <div key={i} style={{ position: 'relative' }}>
                                                    <img
                                                        src={
                                                            img.type === "existing"
                                                                ? `${process.env.REACT_APP_URL}${img.url}`
                                                                : img.url
                                                        }
                                                        width="80"
                                                        height="80"
                                                        style={{ objectFit: 'cover', borderRadius: '4px' }}
                                                        alt=""
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => handleRemoveImage(img, i)}
                                                        style={{
                                                            position: 'absolute',
                                                            top: -5,
                                                            right: -5,
                                                            background: 'red',
                                                            color: '#fff',
                                                            border: 'none',
                                                            borderRadius: '50%',
                                                            cursor: 'pointer'
                                                        }}
                                                    >
                                                        ×
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
 
                            </div>
 
                            <div className="modal-footer">
                                <button className='btn btn-danger' type="button" onClick={closeModal}>Cancel</button>
                                <button className='btn btn-success' type="submit" disabled={loading}>
                                    {loading ? "Updating..." : "Update"}
                                </button>
                            </div>
 
                        </form>
                    </div>
 
                </div>
            </div>
        </div>
    );
}
 
export default UpdateMenu;